import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { filter, map } from 'rxjs';
import { AnswersStore } from 'src/app/store/answers-store';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Answer } from 'src/app/models/Answer.model';
import { AutoResizeDirective } from 'src/app/directves/autoresize.directive';

@Component({
    selector: 'que-fill-question-display',
    imports: [CommonModule, ReactiveFormsModule, AutoResizeDirective],
    templateUrl: './fill-question-display.component.html',
    styleUrls: ['./fill-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FillQuestionDisplayComponent implements OnInit {

  @Input()
  question?: Question;
  @Input() modularId?: string;
  @Input() modularOrder?: number;
  @Input() viewAnswer = false;
  myAnswer?: Answer;
  answer = new FormControl();
  #answerStore = inject(AnswersStore);

  eventDeleteModularuestionId$ = this.#answerStore.eventDeleteModularuestionId$;

  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));

  ngOnInit(): void {
    this.answer.setValidators(this.question?.requierd ? [Validators.required] : null);

    this.eventDeleteModularuestionId$.pipe(filter(id => id != undefined && id == this.question?.id)).subscribe(
      x => {
        this.getAnswers()
      }
    )
    this.isNotUser$.subscribe((isNotUser) => {
      if (isNotUser) {
        this.answer.disable();
      } else {
        this.answer.enable();
      }
    });
    this.getAnswers();
  }
  getAnswers() {
    this.answer.valueChanges.subscribe(
      ans => {
        if (!!this.question?.isFilterField) {
          this.#answerStore.updateMainAnswerAndSync(ans);
        }
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, modularQuestionGuid: this.modularId, modularRowNum: this.modularOrder, textAnswer: ans, isValid: this.answer.valid })
      });
    this.#answerStore.answers$.pipe(map(arr => arr.find(ans => ans.questionId == this.question?.id && (!this.modularId || (ans.modularQuestionGuid == this.modularId && ans.modularRowNum == this.modularOrder))))).subscribe(x => {
      if (x) {
        this.myAnswer = x;
        this.answer.setValue(x.textAnswer, { emitEvent: false });
      }
    }).unsubscribe();
  }
}
